(() => {
  const instances = new WeakMap();
  const boot = async root => {
    if (instances.has(root)) return;
    const fallback = root.querySelector('[data-product-fallback]');
    const mount = root.querySelector('[data-product-mount]');
    const notice = root.querySelector('[data-product-notice]');
    const noticeText = notice?.textContent ?? '';
    let stage = 'Konfiguration';
    const record=(error,how)=>{try{const prev=JSON.parse(localStorage.getItem('nordestic-last-error')||'[]');const list=Array.isArray(prev)?prev:[];list.unshift({t:new Date().toISOString(),how,stage,msg:String(error?.message||error).slice(0,400),stack:String(error?.stack||'').slice(0,1800),url:location.pathname+location.search,ref:String(document.referrer||'').slice(0,120),ready:document.readyState,slots:document.querySelectorAll('[data-nordestic-slot]').length,ua:navigator.userAgent.slice(0,160)});localStorage.setItem('nordestic-last-error',JSON.stringify(list.slice(0,5)));}catch{}};
    let restarts = 0, leaving = false;
    const reloadOnce=()=>{try{const now=Date.now(),last=Number(sessionStorage.getItem('nordestic-reload')||0);if(now-last<60000)return false;sessionStorage.setItem('nordestic-reload',String(now));leaving=true;location.reload();return true;}catch{return false}};
    if (!fallback || !mount) return;
    const controller = new AbortController();
    let stopped = false, unmount, timer, fallbackChanged = false;
    fallback.addEventListener('change',()=>{fallbackChanged=true;},{signal:controller.signal});
    const ownedStyles = [];
    const stop = () => {
      stopped = true;
      clearTimeout(timer);
      controller.abort();
      unmount?.();
      ownedStyles.forEach(link => link.remove());
      instances.delete(root);
    };
    instances.set(root, stop);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) stop();
    }, {signal:controller.signal});
    const fail = error => {
      if (stopped || leaving) return;
      record(error,'notansicht');
      clearTimeout(timer);
      mount.hidden = true;
      fallback.removeAttribute('data-pending');
      fallback.hidden = false;
      fallback.inert = false;
      if (notice) {
        notice.hidden = false;
        if(!window.Shopify?.designMode&&!notice.querySelector('[data-product-code]')){const code=document.createElement('small');code.setAttribute('data-product-code','');code.style.cssText='display:block;margin-top:8px;font-size:11px;line-height:1.4;opacity:.6;word-break:break-word;-webkit-user-select:all;user-select:all';code.textContent='Fehlercode: '+stage+' · '+String(error?.message||error).slice(0,160);notice.append(code);}
        if(window.Shopify?.designMode){
          const reason=error?.message==='Ungültiges Shopify-Produktbild'?'MEDIA_URL':error?.message==='Product stylesheet unavailable'?'CSS_LOAD':error?.message==='Product loading timed out'?'TIMEOUT':'APP_LOAD';
          notice.textContent=noticeText+' (Diagnose: '+stage+' / '+reason+' – '+String(error?.message||error).slice(0,300)+')';
        }
      }
      console.warn('Nordestic product page could not load', error, error?.stack);
    };
    // Erst neu laden (einmal), dann Notansicht. Nicht im Theme-Editor und nicht, wenn im Notformular schon gewaehlt wurde.
    const recover = error => {
      if (stopped || leaving) return;
      if (window.Shopify?.designMode || fallbackChanged) { fail(error); return; }
      record(error,'neu-laden');
      console.warn('Nordestic product page: recovering', error, error?.stack);
      if (!reloadOnce()) fail(error);
    };
    try {
      const config = JSON.parse(root.querySelector('[data-product-config]').textContent);
      // The theme editor renders the preview in a frame whose location/baseURI can be
      // unusable as a URL base (e.g. about:srcdoc). Derive the shop origin from the
      // absolute asset URL that Liquid rendered instead of relying on location.
      const proto = (() => {
        for (const candidate of [location.href, document.baseURI]) {
          try { const p = new URL(candidate).protocol; if (p === 'https:' || p === 'http:') return p; } catch {}
        }
        return 'https:';
      })();
      const shopOrigin = (() => {
        for (const candidate of [config.entry, location.origin, document.baseURI]) {
          try {
            const u = new URL(String(candidate).startsWith('//') ? proto + candidate : candidate);
            if (u.protocol === 'https:' || u.protocol === 'http:') return u.origin;
          } catch {}
        }
        return 'https://nordestic.de';
      })();
      const abs = url => new URL(String(url).startsWith('//') ? proto + url : url, shopOrigin).href;
      config.entry = abs(config.entry); config.css = config.css.map(abs);
      const variantIds = new Set(config.catalog.variants.map(variant => String(variant.id)));
      const duplicate = document.querySelector('[data-niva-studio]') ||
        [...document.querySelectorAll('form[action*="/cart/add"]')].some(form =>
          !root.contains(form) && [...form.querySelectorAll('[name="id"]')].some(input => variantIds.has(input.value)));
      if (duplicate || document.querySelectorAll('[data-nordestic-product]').length !== 1) {
        fail(new Error('Duplicate product purchase section'));
        if (window.Shopify?.designMode && notice) notice.textContent = 'Bitte die zweite Kauf-Section für dieses Produkt oder den Niva-Zusatzdialog aus dieser Vorlage entfernen.';
        return;
      }
      const allowed = () => {try{const cp=window.Shopify?.customerPrivacy;return typeof cp?.analyticsProcessingAllowed==='function'&&cp.analyticsProcessingAllowed()===true;}catch{return false}};
      window.NIVA_HOST = {
        assets:config.assets, thumbnails:config.thumbnails, media:config.media, variantMedia:config.variantMedia, mediaRoles:config.mediaRoles, judge:config.judge, catalog:config.catalog, productId:config.productId,
        title:config.title, settings:config.settings, images:config.images,
        productUrl:abs(config.productUrl), currency:config.currency,
        country:config.country, mode:'page', paymentIcons:typeof config.paymentIcons==='string'&&config.paymentIcons.trim()?config.paymentIcons:undefined, cartRoot:String(config.cartRoot||'/').replace(/\/?$/,'/'), swiss:config.swiss||undefined,
        configurationSearch:location.search, analyticsAllowed:allowed,
        track:(name,payload) => {if(allowed())try{window.Shopify?.analytics?.publish(name,payload);}catch{}},
        openCart:() => {
          const event = new CustomEvent('nordestic:cart-added',{cancelable:true,detail:{cartUrl:abs(String(config.cartRoot||'/').replace(/\/?$/,'/')+'cart')}});
          if(document.dispatchEvent(event))location.assign(abs(String(config.cartRoot||'/').replace(/\/?$/,'/')+'cart'));
        },
      };
      if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});
      timer = setTimeout(() => recover(new Error('Product loading timed out')), 15000);
      stage = 'Dateien laden';
      const styles = config.css.map(url => new Promise((resolve,reject) => {
        let link = [...document.querySelectorAll('link[rel="stylesheet"]')].find(item => item.href === url);
        if (link?.sheet) {resolve();return;}
        const isNew = !link;
        if (!link) {link=document.createElement('link');link.rel='stylesheet';link.href=url;ownedStyles.push(link);}
        link.addEventListener('load',resolve,{once:true,signal:controller.signal});
        link.addEventListener('error',()=>reject(new Error('Product stylesheet unavailable')),{once:true,signal:controller.signal});
        if (isNew) document.head.append(link);
      }));
      // CSS and the module graph download together, with no stylesheet -> JS waterfall.
      const [app] = await Promise.all([import(config.entry),Promise.all(styles)]);
      stage = 'Produktansicht starten';
      if (stopped || !root.isConnected) return;
      if(fallbackChanged){
        const selected=fallback.querySelector('[name="id"]')?.value;
        if(selected){const params=new URLSearchParams(location.search);['size','color','height','custom'].forEach(key=>params.delete(key));params.set('variant',selected);window.NIVA_HOST.configurationSearch=params.toString();}
      }
      const start = () => { unmount = app.mountProductPage(mount,{
        onReady:() => {
          if (stopped) return;
          clearTimeout(timer);
          const focusWasInside=fallback.contains(document.activeElement);
          fallback.inert=true;
          fallback.hidden=true;
          mount.hidden=false;
          try{const nH=fallback.querySelector('h1');if(nH){const nP=document.createElement('p');nP.textContent=nH.textContent;nH.replaceWith(nP);}document.querySelectorAll('[data-n-ssr]').forEach(nE=>nE.remove());}catch{}
          if(focusWasInside){const heading=mount.querySelector('h1');heading?.setAttribute('tabindex','-1');heading?.focus({preventScroll:true});}
        },
        onError:error => {
          if (stopped || leaving) return;
          if (restarts < 1 && !window.Shopify?.designMode) {
            // Stiller Neustart der Ansicht (ohne Seite neu zu laden)
            restarts += 1; stage = 'Neustart'; record(error,'neustart');
            console.warn('Nordestic product page: restarting view', error, error?.stack);
            clearTimeout(timer);
            timer = setTimeout(() => recover(new Error('Product loading timed out')), 15000);
            setTimeout(() => {
              const old = unmount; unmount = undefined;
              try { old?.(); } catch {}
              if (stopped || leaving || !root.isConnected) return;
              try { start(); } catch (again) { recover(again); }
            }, 0);
            return;
          }
          recover(error);
        },
      }); };
      start();
    } catch (error) {recover(error);}
  };
  // Diagnose: <Produktseite>?ndiag=1 zeigt die zuletzt gemerkten Fehler dieses Browsers.
  try{if(/[?&#]ndiag\b/.test(location.search+location.hash)){const box=document.createElement('pre');box.style.cssText='position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;max-height:60vh;overflow:auto;margin:0;padding:12px;border-radius:10px;background:#111;color:#e8ffe8;font:11px/1.4 ui-monospace,Menlo,monospace;white-space:pre-wrap;word-break:break-word;-webkit-user-select:text;user-select:text';let txt='kein Fehler gespeichert';try{const raw=localStorage.getItem('nordestic-last-error');if(raw)txt=JSON.stringify(JSON.parse(raw),null,1);}catch{}box.textContent='Nordestic Diagnose (R177)\n'+txt;document.body.append(box);}}catch{}
  document.querySelectorAll('[data-nordestic-product]').forEach(boot);
  document.addEventListener('shopify:section:load',event=>{
    // Profile/host modules are document-bound. Reload only our own replacement section.
    if(event.target.matches?.('[data-nordestic-product]')||event.target.querySelector('[data-nordestic-product]'))location.reload();
  });
})();
